import { useState } from 'react'
import { errorMessage } from '@/api/http'
import { auth } from '@/lib/auth'
import { Button, Card, ErrorBox, Field, Input } from '@/components/ui'

export function LoginPage({ redirect }: { redirect?: string }) {
  const [mode, setMode] = useState<'login' | 'register'>('login')
  const [displayName, setDisplayName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    setBusy(true)
    try {
      if (mode === 'login') {
        await auth.login(email, password)
      } else {
        await auth.register(email, password, displayName)
      }
      // Tvrdy prechod pres href je tu schvalne: po prihlaseni se meni kontext
      // routeru (auth) a nacteni cile nacisto je jistejsi nez ho invalidovat.
      window.location.href = redirect ?? '/texts'
    } catch (err) {
      setError(errorMessage(err, mode === 'login' ? 'Přihlášení se nezdařilo' : 'Registrace se nezdařila'))
      setBusy(false)
    }
  }

  return (
    <Card>
      <form onSubmit={submit} className="space-y-4">
        <div className="flex gap-1 rounded-lg bg-slate-100 p-1">
          {(['login', 'register'] as const).map((m) => (
            <button
              key={m}
              type="button"
              onClick={() => {
                setMode(m)
                setError(null)
              }}
              className={`flex-1 rounded-md px-3 py-1.5 text-sm font-medium transition ${
                mode === m ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-700'
              }`}
            >
              {m === 'login' ? 'Přihlášení' : 'Registrace'}
            </button>
          ))}
        </div>

        {mode === 'register' && (
          <Field label="Jméno" hint="Nepovinné — jen do hlavičky">
            <Input
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
              placeholder="Miloslav"
              autoComplete="name"
            />
          </Field>
        )}

        <Field label="E-mail">
          <Input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="jmeno@email.cz"
            required
            autoComplete="username"
          />
        </Field>

        <Field label="Heslo" hint={mode === 'register' ? 'Aspoň 10 znaků' : undefined}>
          <Input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete={mode === 'login' ? 'current-password' : 'new-password'}
          />
        </Field>

        <ErrorBox message={error} />

        <Button type="submit" className="w-full" disabled={busy}>
          {busy ? 'Odesílám…' : mode === 'login' ? 'Přihlásit' : 'Založit účet'}
        </Button>
      </form>
    </Card>
  )
}
